/* eslint-disable no-undef */
if (!customElements.get('media-gallery')) {
  // It is strongly coupled this sliderComponent, productModal and modalOpener classes.
  // Any update should take those classes into account.
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.isScrolled = false; // Used to prevent infinite loop of events when scrolling the thumbnail or viewer sliders
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      document.addEventListener('slideChanged', this.onSlideChanged.bind(this));

      this.elements.thumbnails.querySelectorAll('[data-global-media-id]').forEach((mediaToSwitch, index) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.globalMediaId, false));
        if (index === 0) mediaToSwitch.querySelector('button').click();
      });
      if (this.dataset?.desktopLayout?.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target*="${event.detail.currentElement.dataset.globalMediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    connectedCallback() {
      this.sliderComponentGroupId = this.dataset.sliderComponentGroupId;
      document.addEventListener('slideChangedInViewer', this.updateViewerSliderMediaGallery.bind(this));
      document.addEventListener('slideChangedInModal', this.onSlideChangedInModal.bind(this));
    }

    onSlideChangedInModal(event) {
      // Apply slider synchronization based on group ID, so one slider does not update multiple modal sliders
      const target = event.detail.target;
      this.updateViewerSliderMediaGallery(event, target);

    }

    updateViewerSliderMediaGallery(event, target) {
      if (event.detail.sliderComponentGroupId !== this.sliderComponentGroupId) return;

      if (target) {
        this.updateSlidersMediaGallery({target, triggerScroll: true, syncSliders: false});
      } else {
        const currentTarget = event?.detail?.currentElement?.dataset?.globalMediaId;
        if (!this.isScrolled) this.updateSlidersMediaGallery({target: currentTarget, triggerScroll: false, syncSliders: true});
        this.isScrolled = false;
      }
    }

    updateSlidersMediaGallery({target, triggerScroll, syncSliders}) {
      const sliders = this.querySelectorAll('slider-component') || [];
      sliders.forEach((slider) => {
        const updatedActiveSlide = slider.querySelector(`[data-global-media-id="${target}"]`);
        if (updatedActiveSlide) {
          let slides = slider.querySelectorAll('li.slider__slide');
          slides.forEach((slide) => {
            slide.classList.remove('is-active');
          });
          updatedActiveSlide.classList.add('is-active');
        }
      });

      if (triggerScroll) {
        this.isScrolled = true;
        const updatedActiveSlideViewer = this.querySelector(`[id^="GalleryViewer"] [data-global-media-id="${target}"]`);
        updatedActiveSlideViewer.scrollIntoView({ behavior: 'instant' });
      }

      if (syncSliders) {
        document.dispatchEvent(
          new CustomEvent('slideChangedInGallery', {
            detail: {
              target: target,
              sliderComponentGroupId: this.sliderComponentGroupId,
            }
          })
        );
      }
      
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-global-media-id="${ mediaId }"]`);
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-global-media-id="${ mediaId }"]`);

      if (prepend) {
        activeMedia?.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          activeThumbnail?.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia?.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'instant' });
        }
        if (activeThumbnail) {
          activeThumbnail.scrollIntoView({ behavior: 'smooth' });
        }
        this.setActiveThumbnail(activeThumbnail);
      });
      this.playActiveMedia(activeMedia);
      this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail || !this.sliderComponentGroupId) return;
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop + thumbnail.offsetHeight });
    }

    announceLiveRegion(activeItem, position) {
      if (!this.elements.liveRegion) return;
      const image = activeItem?.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem?.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
